import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/xiyangyang/index.vue')
const Video = () => import('../activity/xiyangyang/video.vue')
const Landing = () => import('../activity/xiyangyang/landing/Index.vue')

export const index: RouteConfig = {
  path: '/activity/xyy',
  name: 'activity-xyy',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
}

export const video: RouteConfig = {
  path: '/activity/xyy/video',
  name: 'activity-xyy-video',
  component: Video,
}

export const landing: RouteConfig = {
  path: '/activity/xyy/landing',
  name: 'activity_xyy_landing',
  component: Landing,
}

export default [index, video, landing]
